export default function StatsBand() {
  return (
    <section className="w-full">
      <img
        src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/147369fe0d9ec14348929ee0855dfa59.png"
        alt="Resultado não se promete, se comprova — números reais de empresas atendidas, participantes ativos e taxa de ativação em campanhas de incentivo GetPoints"
        title="Resultados de campanhas de incentivo GetPoints"
        className="h-auto w-full"
      />
    </section>
  );
}